import React, { useState } from "react";
import { connect } from "react-redux";
import { Input, Button, Toastr } from "../../../revvComponents";
import { CustomSelect } from "../../../commonComponents";
import MetaFieldComponentMapping from "../MetaFieldComponentsMapping";

// action imports
import { createMetaFieldAction } from "../../../actions/MetaFieldActions";

const availableOptions = [
  {
    name: "DATE",
    label: "Date",
    id: 4,
    props: {
      format: {
        required: true,
        valid_formats: [
          "DD-Mon-YY",
          "DD-Mon-YYYY",
          "mm/dd/yy",
          "mm/dd/yyyy",
          "dd.mm.yy",
          "dd.mm.yyyy",
          "yy/mm/dd",
          "yyyy/mm/dd",
          "Mon YYYY",
          "Month DD, YYYY",
          "Mon dd yyyy",
          "DD Mon, YYYY",
          "DD Month, YYYY",
          "dd-mm-yyyy",
          "mm-dd-yyyy",
          "dd/mm/yy",
          "dd/mm/yyyy",
          "mm.dd.yyyy",
          "MMDDYY",
          "MMDDYYYY",
          "YYMMDD",
          "DDMMYY",
        ],
      },
    },
  },
  {
    name: "MULTI_SELECT",
    label: "Multi Select",
    id: 2,
    props: {
      default: {
        required: false,
      },
      options: {
        required: true,
      },
    },
  },

  {
    name: "NUMBER",
    label: "Number",
    id: 8,
    props: {
      default: {
        required: false,
      },
      max: {
        required: false,
      },
      min: {
        required: false,
      },
    },
  },
  {
    name: "SINGLE_SELECT",
    label: "Single select",
    id: 16,
    props: {
      default: {
        required: false,
      },
      options: {
        required: true,
      },
    },
  },
  {
    name: "TEXT",
    label: "Text",
    id: 15,
    props: {
      default: {
        required: false,
      },
    },
  },
];

const MetaFieldBox = props => {
  const [selectedMetaField, handleselectMetaField] = useState({
    id: 15,
    name: "TEXT",
    label: "Text",
    props: {
      default: {
        required: false,
      },
    },
  });
  const [metaFieldName, handleMetaFieldName] = useState("");
  const [defaultData, setMetaFieldValues] = useState({});
  const checkFieldNameIsDuplicate = docMode => {
    const { metaGroups } = props;
    const docLevel = docMode === "documents" ? "DOCUMENT" : "TEMPLATE";
    let metaFieldsList = [];
    metaGroups.forEach(metaGroup => {
      if (metaGroup.level === docLevel) {
        metaFieldsList = Object.keys(metaGroup.meta.fields);
      }
    });
    if (metaFieldsList.includes(metaFieldName)) return true;
    return false;
  };
  const createMetaField = () => {
    const { mode } = props;
    const metaFieldNameInfo = metaFieldName.trim();
    const metaFieldData = {
      fields: {
        [metaFieldNameInfo]: {
          field_type: mode === "DOCUMENT" ? "TEXT" : selectedMetaField.name,
          field_meta: defaultData,
          value: defaultData.default || "",
        },
      },
    };

    const docMode = props.templateObjectId ? "templates" : "documents";
    const isDuplicate = checkFieldNameIsDuplicate(docMode);
    if (!isDuplicate) {
      if (
        selectedMetaField.name === "SINGLE_SELECT" ||
        selectedMetaField.name === "MULTI_SELECT"
      ) {
        switch (selectedMetaField.name) {
          case "SINGLE_SELECT": {
            if (defaultData && defaultData.options.length < 2) {
              Toastr.showToastr({
                type: "failure",
                message: "Atleast two options should be available.",
                timeout: 6000,
              });
            } else {
              const objectId = props.templateObjectId || props.documentObjectId;
              props.createMetaFieldAction(docMode, objectId, metaFieldData);
              props.handleCreateMetaFieldBox(false);
            }
            break;
          }
          case "MULTI_SELECT": {
            if (defaultData && defaultData.options.length < 1) {
              Toastr.showToastr({
                type: "failure",
                message: "Atleast one options should be available.",
                timeout: 6000,
              });
            } else {
              const objectId = props.templateObjectId || props.documentObjectId;
              props.createMetaFieldAction(docMode, objectId, metaFieldData);
              props.handleCreateMetaFieldBox(false);
            }
            break;
          }
          default:
            break;
        }
      } else {
        const objectId = props.templateObjectId || props.documentObjectId;
        props.createMetaFieldAction(docMode, objectId, metaFieldData);
        props.handleCreateMetaFieldBox(false);
      }
    } else {
      Toastr.showToastr({
        type: "failure",
        message: "Meta field cannot be duplicte.",
        timeout: 6000,
      });
    }
  };
  const getMetaFieldOptions = value => {
    if (value && value !== "") {
      const FieldMapping = MetaFieldComponentMapping[value];
      if (FieldMapping === undefined) {
        return (
          <React.Fragment>
            <b>Nothing is defined for this field !</b>
          </React.Fragment>
        );
      }
      return (
        <React.Fragment>
          <FieldMapping
            value={value}
            metaFieldName={metaFieldName}
            setMetaFieldValues={setMetaFieldValues}
          />
        </React.Fragment>
      );
    }
    return <React.Fragment />;
  };
  return (
    <div className="metafield-create-conatainer">
      <div className="metafield-create-header">Create new Metafield</div>
      <div className="metafield-create-body">
        <div
          className="metafield-revv-form-items-fieldname"
          data-test="metafield-revv-form-items-fieldname">
          <span
            className="metafield-revv-form-items-fieldname-label"
            data-test="metafield-revv-form-items-fieldname-label">
            Field name{" "}
            <span
              className="requiredwitherr-input"
              data-test="metafield-revv-form-items-fieldname-input-fieldname">
              *
            </span>
          </span>
          <Input
            autoFocus
            id="name"
            className="metafield-create-input"
            data-test="metafield-fieldname-input"
            name="field_name"
            type="text"
            value={metaFieldName}
            onChange={e => handleMetaFieldName(e.target.value)}
            required
          />
        </div>
        {props.mode === "TEMPLATE" && (
          <div
            className="metafield-create-section"
            data-test="metafield-create-section">
            <span
              className="metafield-create-section-label"
              data-test="metafield-create-section-label">
              Custom field type
              <span
                className="requiredwitherr-input"
                data-test="customdynamicfieldselect-fieldtype-required-symbol">
                {" "}
                *
              </span>
            </span>
            <CustomSelect
              className="metafield-create-input"
              _handleChangeInSelect={handleselectMetaField}
              options={availableOptions}
              value={selectedMetaField}
            />
          </div>
        )}
        <div
          className="metafield-defaultvalue"
          data-test="metafield-defaultvalue-option">
          {getMetaFieldOptions(selectedMetaField.name)}
        </div>
        <div className="metafield-btns">
          <Button
            className="btn-transparent"
            data-test="btn-transparent-discard"
            onClick={() => props.handleCreateMetaFieldBox(false)}>
            Discard
          </Button>
          <Button
            data-test="btn-transparent-save"
            onClick={() => createMetaField()}
            disabled={
              !(selectedMetaField && metaFieldName && metaFieldName.trim())
            }>
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const {
    customDynamicFieldData,
    template: { object_id: templateObjectId },
  } = state.TemplateStore;
  const {
    document: { objectId: documentObjectId },
  } = state.DocumentStore;
  const { metaGroups } = state.MetaFieldStore;
  return {
    customDynamicFieldData,
    templateObjectId,
    documentObjectId,
    metaGroups,
  };
};

const mapDispatchToProps = { createMetaFieldAction };

export default connect(mapStateToProps, mapDispatchToProps)(MetaFieldBox);
